import "./product-selector.scss";
import { html, LitElement, PropertyValues } from "lit";
import ComponentBase from "./component-base";
import { ChoiceDto, ProductDto } from "../model/dtos";
import { property, state } from "lit/decorators.js";
import "./product-selector-card";

class ProductSelector extends ComponentBase {
  static get tagName() {
    return "ncx-product-selector";
  }

  @property()
  products: ChoiceDto[] = [];
  @property()
  selectedProducts: number[] = [];
  @property()
  multi: boolean = false;

  onProductSelected(ev: CustomEvent) {
    const evt = new CustomEvent("products-selection", {
      detail: ev.detail,
    });
    this.dispatchEvent(evt);
  }

  protected render(): unknown {
    return html`
      ${this.products?.map(
        (product) => html`
          <product-selector-card
            .product=${product}
            .isSelected=${this.selectedProducts.indexOf(product.id) != -1}
            @selected=${this.onProductSelected}
          ></product-selector-card>
        `
      )}
    `;
  }
}
ProductSelector.Register();
export default ProductSelector;
